// eslint-disable-next-line
export const Namespaces = {
  COMMON: 'common',
  DAP: 'dap',
  ACTIVITIES: 'activities',
  CATALOG: 'catalog',
  OB: 'ob',
  SETTINGS: 'settings',
  PPREMIUM: 'ppremium',
  PROFILE: 'profile',
  HOW_IT_WORK: 'how_it_work',
  VALIDATIONS: 'validations',
  RESOURCES: 'resources',
  ASSIGN_ACTIVITY: 'assign_activity',
  CHAT: 'chat',
  CALENDAR_EVENTS: 'calendar_events',
  STUDENT_PROFILE: 'student_profile',
  PORTFOLIO: 'portfolio',
  AUTH: 'auth',
  FEED: 'feed',
};

export const SectionNamespaces = Object.values(Namespaces);
